module.exports = __webpack_public_path__ + "img/MadMix.04eecc98.webp";